var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListaElevatoria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 131,
    viewBox: "0 0 136 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_845_524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8262 70.4762L27.5185 79.2158L44.9032 61.7366M18.8262 111.261L27.5185 120.001L44.9032 102.521M65.1854 70.4762H128.929M65.1854 111.261H128.929M65.1854 29.6914H128.929",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_845_524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 47V31.3333H7.9C7.04158 28.8116 6.60238 26.1651 6.6 23.5C6.6 17.2674 9.06535 11.2901 13.4537 6.88299C17.8421 2.47589 23.7939 0 30 0H56V15.6667H52.1C52.932 18.1211 53.4 20.7583 53.4 23.5C53.4 29.7326 50.9346 35.7099 46.5463 40.117C42.1579 44.5241 36.2061 47 30 47H4ZM11.8 23.5C11.8 26.8422 12.684 29.9494 14.244 32.6389L23.24 27.4167C22.59 26.2678 22.2 24.9361 22.2 23.5C22.2 21.8028 22.746 20.2361 23.656 18.9567L15.18 12.8728C13.1 15.8756 11.8 19.5833 11.8 23.5ZM30 41.7778C36.734 41.7778 42.61 38.0961 45.756 32.6389L36.76 27.4167C35.408 29.7667 32.886 31.3333 30 31.3333H29.246L28.258 41.6994L30 41.7778ZM30 15.6667C33.146 15.6667 35.876 17.5467 37.098 20.2622L46.562 15.9278C45.1167 12.7344 42.7863 10.0266 39.8492 8.12812C36.9122 6.22964 33.4928 5.2208 30 5.22222V15.6667ZM30 20.8889C28.57 20.8889 27.4 22.0639 27.4 23.5C27.4 24.9361 28.57 26.1111 30 26.1111C31.43 26.1111 32.6 24.9361 32.6 23.5C32.6 22.0639 31.43 20.8889 30 20.8889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37333 31.1722C7.53256 28.7023 7.10236 26.1102 7.1 23.4998C7.10005 17.3992 9.51323 11.5489 13.808 7.23579C18.1028 2.92269 23.9272 0.5 30 0.5H55.5V15.1667H52.1H51.4026L51.6265 15.8272C52.4418 18.2324 52.9 20.8155 52.9 23.5C52.9 29.6007 50.4868 35.451 46.192 39.7642C41.8972 44.0773 36.0728 46.5 30 46.5H4.5V31.8333H7.9H8.59837L8.37333 31.1722ZM13.8115 32.8898L14.0625 33.3224L14.495 33.0713L23.491 27.8491L23.9187 27.6008L23.6752 27.1705C23.0647 26.0914 22.7 24.844 22.7 23.5C22.7 21.9118 23.2106 20.4456 24.0634 19.2465L24.352 18.8408L23.9476 18.5505L15.4716 12.4666L15.0585 12.1701L14.769 12.5881C12.6362 15.6671 11.3 19.4729 11.3 23.5C11.3 26.9321 12.2082 30.1256 13.8115 32.8898ZM29.9775 42.2773L29.9888 42.2778H30C36.9212 42.2778 42.9582 38.4932 46.1892 32.8886L46.4381 32.4567L46.007 32.2065L37.011 26.9842L36.5769 26.7322L36.3266 27.1673C35.0602 29.3685 32.7 30.8333 30 30.8333H29.246H28.7914L28.7483 31.2859L27.7603 41.652L27.7104 42.1753L28.2355 42.1989L29.9775 42.2773ZM29.5 15.6667V16.1667H30C32.9424 16.1667 35.4979 17.925 36.642 20.4674L36.8486 20.9264L37.3062 20.7168L46.7702 16.3824L47.2228 16.1751L47.0175 15.7216C45.5328 12.441 43.1385 9.65893 40.1206 7.70821C37.1028 5.75748 33.5891 4.72076 29.9998 4.72222L29.5 4.72243V5.22222V15.6667ZM30 20.3889C28.2918 20.3889 26.9 21.7898 26.9 23.5C26.9 25.2102 28.2918 26.6111 30 26.6111C31.7082 26.6111 33.1 25.2102 33.1 23.5C33.1 21.7898 31.7081 20.3889 30 20.3889Z",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_845_524",
    x: 11.8262,
    y: 26.6914,
    width: 124.104,
    height: 104.31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_845_524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_845_524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_845_524",
    x: 0,
    y: 0,
    width: 60,
    height: 55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_845_524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_845_524",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListaElevatoria);
export default __webpack_public_path__ + "static/media/listaElevatoria.0f75932ae5677a4bb7bd1b60e59779a7.svg";
export { ForwardRef as ReactComponent };